import { PaymentLineItemType } from '@prisma/client';
import { ReportAppointment, ReportOrder } from '../../types/reports';
import { getOrderItemName } from '../orders';

export const getOrderPaymentPaidAmountWithLineItems = ({
  payment,
  order,
  selectedProducts,
  includeTaxes,
  includeTips,
  lineItemTypes,
}: {
  payment: ReportOrder['payments'][number];
  order: ReportOrder;
  selectedProducts: string[];
  includeTaxes: boolean;
  includeTips: boolean;
  lineItemTypes?: PaymentLineItemType[];
}) => {
  const selectedItems = order.orderItems.filter(item =>
    selectedProducts.includes(getOrderItemName(item)),
  );
  const selectedLineItems = selectedItems.flatMap(item => {
    const paymentLineItems = payment.lineItems.filter(
      lineItem => lineItem.orderItemId === item.orderItemId,
    );
    return paymentLineItems;
  });
  const tipLineItems = !payment.appointmentId
    ? payment.lineItems.filter(
        lineItem => lineItem.type === PaymentLineItemType.TIP,
      )
    : [];

  const lineItemTypesToInclude = new Set<PaymentLineItemType>(
    lineItemTypes || ['RETAIL_ITEM'],
  );

  if (includeTaxes) {
    lineItemTypesToInclude.add('RETAIL_ITEM_TAX');
  }

  const totalSelectedAmount = selectedLineItems.reduce((sum, item) => {
    if (lineItemTypesToInclude.has(item.type)) {
      return sum + item.amount / 100;
    }
    return sum;
  }, 0);

  const totalTipAmount = includeTips
    ? tipLineItems.reduce((sum, item) => sum + item.amount / 100, 0)
    : 0;

  return totalSelectedAmount + totalTipAmount;
};

export const getAppointmentPaymentPaidAmountWithLineItems = ({
  payment,
  includeTaxes,
  includeTips,
  lineItemTypes,
}: {
  payment: ReportAppointment['payments'][number];
  includeTaxes: boolean;
  includeTips: boolean;
  lineItemTypes?: PaymentLineItemType[];
}) => {
  const selectedLineItems = payment.lineItems;

  const lineItemTypesToInclude = new Set<PaymentLineItemType>(
    lineItemTypes || ['SERVICE'],
  );

  if (includeTaxes) {
    lineItemTypesToInclude.add('SERVICE_TAX');
  }

  if (includeTips) {
    lineItemTypesToInclude.add('TIP');
  }

  const totalSelectedAmount = selectedLineItems.reduce((sum, item) => {
    if (lineItemTypesToInclude.has(item.type)) {
      return sum + item.amount / 100;
    }
    return sum;
  }, 0);

  return totalSelectedAmount;
};
